

































import { defineComponent } from '@nuxtjs/composition-api'
import { productCompareTrack } from '~/helpers/trackings/24orepro/products';
import useProductPage from '~/composables/useProductPage';
import Accordion from '~/components/solepro/Accordion.vue';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';

export default defineComponent({
    components: {
        Accordion,
        PageBuilderComponent
    },
    props: {
        content: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const benchmark = getAsJSON(props.content)
        const { product } = useProductPage();
        const trackProductCompare = () => productCompareTrack(product.value)

        return {
            benchmark,
            product,
            trackProductCompare
        }
    },
    methods: {

    }
})
